// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__91Omo","heading":"Navbar_heading__mHO2m","ul":"Navbar_ul__3m8Td","li":"Navbar_li__q5eS1","link":"Navbar_link__MQaQK"};